import { object, ObjectSchema, string } from 'yup';

import PersonPersonRelationship from '@/types/personPersonRelationship';
import PersonStaffRelationship from '@/types/personStaffRelationship';

const personPersonRelationshipField = (label: string) => {
  return string().nonNullable().label(label);
};

const personStaffRelationshipField = (label: string) => {
  return string().nonNullable().label(label);
};

export const careTeamEditorSchema: ObjectSchema<
  Omit<PersonStaffRelationship, 'staff' | 'relationship_type'>
> = object().shape({
  id: string().optional().label('Relationship ID'),
  person_id: string().required().label('Person'),
  staff_id: personStaffRelationshipField('Staff'),
  relationship_type_id: personStaffRelationshipField('Relationship Type')
});

export const careTeamEditorPersonPersonSchema: ObjectSchema<
  Omit<PersonPersonRelationship, 'related_person' | 'relationship_type' | 'person'>
> = object().shape({
  id: string().optional().label('Relationship ID'),
  person_id: string().required().label('Person'),
  related_person_id: personPersonRelationshipField('Related Person'),
  relationship_type_id: personPersonRelationshipField('Relationship Type')
});
